import { useResize } from "hooks/useResize";

import styles from "./FsnbTreeResizer.module.css";

/**
 * @callback ResizerSaveElemWidth
 * @param {number} width
 * @return {void}
 */

/**
 * Компонент добавляет дереву ФСНБ перетаскиваемую границу,
 * которая позволяет изменять его ширину
 * @param {object} props
 * @param {React.MutableRefObject.current} props.resizableElem - элемент дерева ФСНБ
 * @param {number} props.minWidth - минимальная ширина элемента
 * @param {ResizerSaveElemWidth} [props.saveElemWidth] - функция сохранения ширины элемента
 */
export const FsnbTreeResizer = ({ resizableElem, minWidth, saveElemWidth }) => {
	const { mouseDownHandler } = useResize({ resizableElem, minWidth, saveElemWidth });

	return <div className={styles.resizer} onMouseDown={mouseDownHandler}></div>;
};
